import Vue from "vue";
import VueI18n from "vue-i18n";
import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";
import zhCN from "vant/lib/locale/lang/zh-CN";
import zhHK from "vant/lib/locale/lang/zh-HK";
import esES from "vant/lib/locale/lang/es-ES";
import en from "./en_us";
import zh from "./zh_cn";
import po from "./es_es";
import mo from "./zh_hk";
import { locale } from "core-js";

Vue.use(VueI18n);

let lang = window.localStorage.getItem('lang') || 'mo';

const messages = {
  mo: {
    ...zhHK,
    ...mo
  },
 
  zh: {
    ...zhCN,
    ...zh
  },
  en: {
    ...enUS,
    ...en
  },

  po: {
    ...esES,
    ...po
  },

};

const i18n = new VueI18n({
  locale: lang, // 设置默认语言
  messages: messages // 设置资源文件对象
});

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales(lang) {


  if (lang.indexOf("zh") != -1) {
    Locale.use(lang, zhCN);
    window.localStorage.setItem("lang", 'zh'); //保存用户语言习惯
    i18n.locale = 'zh';
  } else if (lang.indexOf("en") != -1) {
    Locale.use(lang, enUS);
    window.localStorage.setItem("lang", 'en'); //保存用户语言习惯
    i18n.locale = 'en';
  } else if (lang.indexOf("po") != -1) {
    Locale.use(lang, esES);
    window.localStorage.setItem("lang", 'po'); //保存用户语言习惯
    i18n.locale = 'po';
  } else {
    Locale.use(lang, zhHK);
    window.localStorage.setItem("lang", 'mo'); //保存用户语言习惯
    i18n.locale = 'mo';
  }

  
  
}

export { i18n, vantLocales };
